import type { TruckMakeView, TruckModelView } from '../truck-models.api';

const byName = (a: { name: string }, b: { name: string }) => a.name.localeCompare(b.name);

/** The catalogue after a make was added; an add the server answered with an entry already listed (a respelling) changes nothing. */
export function withMake(makes: TruckMakeView[], added: TruckModelView): TruckMakeView[] {
  if (makes.some((make) => make.id === added.id)) return makes;
  return [...makes, { id: added.id, name: added.name, models: [] }].sort(byName);
}

export function withModel(makes: TruckMakeView[], makeId: string, added: TruckModelView): TruckMakeView[] {
  return makes.map((make) => {
    if (make.id !== makeId || make.models.some((model) => model.id === added.id)) return make;
    return { ...make, models: [...make.models, added].sort(byName) };
  });
}
